// Ported from nenda-autoplayer's src/types/error.ts (PlaybackErrorLevel only —
// autoplayer's ErrorCode enum is app-shell/Sentry plumbing this port doesn't use).
export enum PlaybackErrorLevel {
  WARNING = "WARNING",
  FAILURE = "FAILURE",
}
